// Go.js is a progressive JavaScript library for building interactive diagrams on HTML5
// Created by Luis Carlos Hurtado ♠ luiscarloshurtado@live.com

import Go from "./go.init";
import Array from "./go.array";
import Errors from "./go.errors";
import GoObject from "./go.object";
import GoIs from "./go.is";
import GoString from "./go.string";
import GoStyle from "./go.style";
import GoElement from "./go.element";
import GoDom from "./go.dom";
import GoKeyboard from "./go.keyboard";
import GoFn from "./go.function";
import GoMath from "./go.math";
import GoStore from "./go.store";
import GoComponent from "./go.component";
import GoUrl from "./go.url";
import GoVideo from "./go.video";
import GoMedia from "./go.media";
import GoFiles from "./go.files";
import GoEval from "./go.eval";
import GoDate from "./go.date";
import GoView from "./go.view";
import GoEvents from "./go.events";
import GoGestures from "./go.gestures";
import GoInteract from "./go.interact";
import GoNumbers from "./lib/numbers";
import GoVue from "./lib/vue";
import GO_INCLUDES from "./lib/includes";
import GO_DRAG from "./lib/go.drag.js";
import GO_EVENTS from "./lib/go.events.js";

window.Go = Go;

Object.assign(
  Go,
  Array,
  Errors,
  GoObject,
  GoIs,
  GoString,
  GoStyle,
  GoElement,
  GoDom,
  GoKeyboard,
  GoFn,
  GoMath,
  GoStore,
  GoComponent,
  GoUrl,
  GoEval,
  GoVideo,
  GoMedia,
  GoFiles,
  GoDate,
  GoView,
  GoEvents,
  GoGestures,
  GoInteract,
  GoNumbers,
  GoVue,
  GO_INCLUDES,
  GO_DRAG,
  GO_EVENTS,
);

export default Go;

Go.start();
